import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { Form, Input, Select, Button, message, Modal, Popover } from 'antd'
import { get as SafeGet, isFunction, isEmpty } from 'lodash'
import moment from 'moment'
import FirstBspRecord from '../../edit/bsp-visit/BspPrint'
import BpsReport from '../../edit/evaluation/BpsReport'
import ServiceRecordBrief from '../../edit/subsequent-brief/ServiceRecordBrief'
import SubsequentVisit from '../../edit/subsequent/SubsequentVisit'
import ScaleLog from '../../edit/scale/ScaleLog'
import RequirementAnalysis from '../../edit/components/RequirementAnalysis'
import BrainHealthDetection from '../../edit/components/BrainHealthDetection'
import DrawingReference from '../../edit/painting/DrawingReference'
import MentalTrainingRecord from '../../edit/home-psychology/MentalTrainingRecord'
import SandTableReference from '../../edit/sand/SandTableReference'
import ArtHealingRecord from '../../edit/healing/ArtHealingRecord'
import PeriodEvaluateReport from '../../edit/stage-report/PeriodEvaluateReport'
import PeriodEvaluateEndReport from '../../edit/stage-report-end/PeriodEvaluateReport'
import SubsequentVisitRecordCustom from '../../edit/service-subsequent-complex/SubsequentVisitRecordCustom'
import ServiceTempOne from '../../edit/service-template1/serviceTemp1'
import EvaluationNewModal from '../../edit/evaluation-new/BpsReport'

const LongShowExcelModal = forwardRef((props, ref) => {
  const { onSuccess, dispatch, renderBtn = <div></div>, records, taskDetail } = props
  const [visible, setVisible] = useState(false)

  useImperativeHandle(ref, () => ({
    showModelRef: showModal,
    hideModelRef: hideModal
  }))

  // modal的显示与隐藏
  const showModal = () => {
    setVisible(true)
  }
  const hideModal = () => { setVisible(false) }
  const handleClose = () => { hideModal() }

  const renderExcelItem = (item) => {
    const { taskableType, data } = item
    if (taskableType === 'subsequent_visit_record_brief') {
      return <ServiceRecordBrief info={data} taskDetail={taskDetail} />
    }
    if (taskableType === 'first_visit_bps_record_sheet') {
      return <FirstBspRecord data={data} />
    }
    if (taskableType === 'bps_report') {
      return <BpsReport taskDetail={taskDetail} infos={data} />
    }
    if (taskableType === 'scale_log') {
      return <ScaleLog currentScale={data} types='open' />
    }
    if (taskableType === 'requirement_analysis') {
      return <RequirementAnalysis result={data} />
    }
    if (taskableType === 'brain_health_detection') {
      return <BrainHealthDetection result={data} />
    }
    if (taskableType === 'drawing_reference') {
      return <DrawingReference infos={data} />
    }
    if (taskableType === 'mental_training_record') {
      return <MentalTrainingRecord infos={data} />
    }
    if (taskableType === 'subsequent_visit_record') {
      return <SubsequentVisit infos={data} />
    }
    if (taskableType === 'sand_table_reference') {
      return <SandTableReference infos={data} />
    }
    if (taskableType === 'art_healing_record') {
      return <ArtHealingRecord infos={data} />
    }
    if (taskableType === 'period_evaluate_report') {
      return <PeriodEvaluateReport info={data} taskDetail={taskDetail} />
    }
    if (taskableType === 'conclude_report') {
      return <PeriodEvaluateEndReport info={data} taskDetail={taskDetail} />
    }
    if (taskableType === 'serve_record_module_one') {
      return <ServiceTempOne info={data} taskDetail={taskDetail} />
    }
    // if (taskableType === 'serve_record_module_two') {
    // }
    // if (taskableType === 'serve_record_module_three') {
    // }
    if (taskableType === 'subsequent_visit_record_custom') {
      return <SubsequentVisitRecordCustom infos={data} />
    }
    if (taskableType === 'new_bps_report') {
      return <EvaluationNewModal info={data} taskDetail={taskDetail} />
    }
    // 剩下的就是未知的类型
    return console.log('未知type', taskableType)
  }

  const renderLongReport = () => {
    return <div>
      {
        records.map(item => {
          return renderExcelItem(item)
        })
      }
    </div>
  }

  return (
    <>
      {React.cloneElement(renderBtn, { ...renderBtn.props, onClick: showModal })}
      <Modal
        title='所有报告'
        width={800}
        destroyOnClose
        visible={visible}
        onCancel={handleClose}
        footer={null}
      >
        {renderLongReport()}
      </Modal>
    </>
  )
})


export default Form.create()(LongShowExcelModal)
